export default __webpack_public_path__ + "static/media/DNo.31-1.d2b73f40.jpg";